import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "39e661hpJhBsr0w80qH/HFg", "AdGoogleADM", undefined);

import { E_JSB, E_ADEventType } from "../../EnumBase";
import AdEvent from "../AdEvent";
import { _decorator, log, sys } from "cc";
var ccclass = _decorator.ccclass;

var AdGoogleADM_Call = ccclass(_class = (_temp = /*#__PURE__*/function () {
  function AdGoogleADM_Call() {
    _defineProperty(this, "_bannerLoadTimes", 0);

    _defineProperty(this, "bannerLoaded", false);

    _defineProperty(this, "isBannering", false);

    _defineProperty(this, "_interstitialLoadTimes", 0);

    _defineProperty(this, "interstitialAdLoaded", false);

    _defineProperty(this, "_videoLoadTimes", 0);

    _defineProperty(this, "videoAdLoaded", false);
  }

  var _proto = AdGoogleADM_Call.prototype;

  _proto.firstLoad = function firstLoad() {
    this.createBannerAd();
    this.createInterstitialAd();
    this.createRewardedVideoAd();
  };

  _proto.init = function init() {} //平台进入前台，通过该函数通知游戏
  ;

  _proto.onResume = function onResume() {
    console.log("onResume:");
  } //平台进入后台，通过该函数通知游戏
  ;

  _proto.onPause = function onPause() {
    console.log("onPause:");
  } // 创建Banner广告 创建一次即可，自动刷新广告
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   bannerAdId: string Banner广告ID 需后台申请
  //   position: int 广告位置 1 屏幕顶部 2 屏幕底部
  ;

  _proto.createBannerAd = function createBannerAd() {
    this._bannerLoadTimes = 1;
    this.bannerLoaded = true;
    callJava("preloadAds", [E_JSB.I, E_JSB.S, E_JSB.V], [0, ""]);
    AdEvent.I.handleEvent(E_ADEventType.log, "banner 创建 banner广告");
  };

  _proto.showBannerAd = function showBannerAd() {
    this.isBannering = true;
    callJava("showAds", [E_JSB.I, E_JSB.S, E_JSB.V], [0, ""]);
    AdEvent.I.handleEvent(E_ADEventType.log, "banner 展示 banner广告");
  };

  _proto.hideBannerAd = function hideBannerAd() {
    callJava("hideAds", [E_JSB.I, E_JSB.S, E_JSB.V], [0, ""]);
    AdEvent.I.handleEvent(E_ADEventType.log, "banner 隐藏 banner广告");
    this.isBannering = false;
  };

  _proto.destroyBannerAd = function destroyBannerAd() {
    this.bannerLoaded = false;
    AdEvent.I.handleEvent(E_ADEventType.log, "banner 销毁 banner广告");
  } // 创建插屏广告 展示一次调用一次创建
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   interstitialAdId: string 插屏广告ID 需后台申请
  //   style: int 广告类型 1 全屏 2 半屏
  ;

  _proto.createInterstitialAd = function createInterstitialAd() {
    this._interstitialLoadTimes = 0;
    callJava("preloadAds", [E_JSB.I, E_JSB.S, E_JSB.V], [1, ""]);
    AdEvent.I.handleEvent(E_ADEventType.log, "interstitial 创建");
  };

  _proto.showInterstitialAd = function showInterstitialAd() {
    callJava("showAds", [E_JSB.I, E_JSB.S, E_JSB.V], [1, ""]);
    AdEvent.I.handleEvent(E_ADEventType.log, "interstitial 展示");
  } // 创建激励视频广告 展示一次创建一次
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   videoAdId: string 视频广告ID 需后台申请
  //   screenOrientation: int 广告类型 1 横屏 2 竖屏
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {
    this._videoLoadTimes = 0;
    callJava("preloadAds", [E_JSB.I, E_JSB.S, E_JSB.V], [2, ""]);
    AdEvent.I.handleEvent(E_ADEventType.log, "video 创建");
  };

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    callJava("showAds", [E_JSB.I, E_JSB.S, E_JSB.V], [2, ""]);
    AdEvent.I.handleEvent(E_ADEventType.log, "video 展示");
  };

  _proto.destroyRewardedVideoAd = function destroyRewardedVideoAd() {
    this.videoAdLoaded = false;
    AdEvent.I.handleEvent(E_ADEventType.log, "video 销毁");
  };

  return AdGoogleADM_Call;
}(), _temp)) || _class;

export { AdGoogleADM_Call as default };
/**
 * 调用java函数
 * @param func 调用目标函数名字
 * @param paramType 参数类型
 * @param param 参数列表
 */

function callJava(func, paramType, param) {
  if (param === void 0) {
    param = [];
  }

  log(paramType + "   --callJava--  param: ", param);

  if (sys.isNative) {
    var _jsb$reflection;

    var aimParamType = "";
    var r_type = paramType.splice(paramType.length - 1, 1);
    var t = "";

    for (var i = 0; i < paramType.length - 1; i++) {
      t += paramType[i];
    }

    aimParamType = "(" + t + ")" + r_type;
    return (_jsb$reflection = jsb.reflection).callStaticMethod.apply(_jsb$reflection, ["org/cocos2dx/javascript/service/GoogleADM", func, aimParamType].concat(param));
  } else {
    log.apply(void 0, [func, paramType].concat(param));
  }
}

var E_AdGoogleADM_Call_JSBType;

(function (E_AdGoogleADM_Call_JSBType) {
  E_AdGoogleADM_Call_JSBType["SDK_Init"] = "sdk_init";
  E_AdGoogleADM_Call_JSBType["Reward_show_fail"] = "reward_show_fail";
  E_AdGoogleADM_Call_JSBType["Reward_gift_gain"] = "reward_gift_gain";
  E_AdGoogleADM_Call_JSBType["Reward_gift_close"] = "reward_gift_close";
  E_AdGoogleADM_Call_JSBType["Interstitail_close"] = "interstitail_close";
})(E_AdGoogleADM_Call_JSBType || (E_AdGoogleADM_Call_JSBType = {}));

window["AdGoogleADM_Call_Call"] = function (type) {
  for (var _len = arguments.length, param = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    param[_key - 1] = arguments[_key];
  }

  log("AdGoogleADM_Call_Call  type = ", type, "  param = ", param);

  switch (type) {
    case E_AdGoogleADM_Call_JSBType.SDK_Init:
      AdEvent.I.handleEvent(E_ADEventType.sdk_init);
      break;

    case E_AdGoogleADM_Call_JSBType.Interstitail_close:
      setTimeout(function () {
        callJava("preloadAds", [E_JSB.I, E_JSB.S, E_JSB.V], [1, ""]);
      }, 100);
      break;

    case E_AdGoogleADM_Call_JSBType.Reward_show_fail:
      AdEvent.I.handleEvent(E_ADEventType.video_showFail);
      break;

    case E_AdGoogleADM_Call_JSBType.Reward_gift_gain:
      AdEvent.I.handleEvent(E_ADEventType.video_showOver);
      setTimeout(function () {
        callJava("preloadAds", [E_JSB.I, E_JSB.S, E_JSB.V], [2, ""]);
      }, 100);
      break;

    case E_AdGoogleADM_Call_JSBType.Reward_gift_close:
      // AdEvent.I.handleEvent(E_ADEventType.video_close);AdGoogleADM_Call
      AdEvent.I.handleEvent(E_ADEventType.video_showFail);
      setTimeout(function () {
        callJava("preloadAds", [E_JSB.I, E_JSB.S, E_JSB.V], [2, ""]);
      }, 100);
      break;
  }
};

_cclegacy._RF.pop();